module.exports = __webpack_public_path__ + "img/logo-red.704f7717.webp";